export const DEFAULT_SLA_TARGET_SECONDS = 10;
export const MIN_SLA_TARGET_SECONDS = 1;
